import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { graphql } from "react-apollo";
import { mutationAddCustomerFieldType } from "Apollo";
import { ShowNotice } from "Store";
import Modal from "module-common/Modal";
import Button from "module-common/Button";
import InputRowRaw from "module-common/InputRow";

export default graphql(mutationAddCustomerFieldType)(
  class AddFieldModal extends Component {
    static propTypes = {
      onCancel: PropTypes.func,
      onConfirm: PropTypes.func
    };
    state = {
      field: "",
      loading: false
    };

    render() {
      const { onCancel } = this.props;
      const { field, loading } = this.state;
      return (
        <Modal>
          <Wrapper>
            <Text>Add Field</Text>
            <form
              onSubmit={event => {
                this.onConfirm();
                event.preventDefault();
              }}
            >
              <InputRow
                labelWidth={100}
                label="Field Name"
                value={field}
                onChange={text => {
                  this.setState({ field: text });
                }}
              />
              <SubmitButton type="submit" />
            </form>
            <Buttons>
              <Button
                width={100}
                onClick={onCancel}
                color="gray"
                disabled={loading}
              >
                Cancel
              </Button>
              <Button
                width={100}
                onClick={this.onConfirm}
                loading={loading}
                disabled={loading}
              >
                Add
              </Button>
            </Buttons>
          </Wrapper>
        </Modal>
      );
    }

    onConfirm = async () => {
      const { onConfirm, mutate } = this.props;
      const { field } = this.state;

      if (onConfirm) {
        if (field) {
          this.setState({ loading: true });
          try {
            await mutate({
              variables: { name: field, displayName: field },
              refetchQueries: ["getCustomerFieldType"]
            });
            onConfirm();
            ShowNotice("customer-field-template-add-success");
          } catch (error) {
            ShowNotice("customer-field-template-add-error");
          }
          this.setState({ loading: false });
        } else {
          ShowNotice("customer-field-template-incomplete-field-error");
        }
      }
    };
  }
);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 320px;
  align-items: center;
`;
const Text = styled.div`
  color: ${props => props.theme.uiText};
  text-align: center;
  font-size: 1.2rem;
  margin-bottom: 10px;
`;
const Buttons = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  & > *:first-child {
    margin-right: 20px;
  }
`;
const SubmitButton = styled.button`
  display: none;
`;
const InputRow = styled(InputRowRaw)`
  margin-bottom: 10px;
`;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/customer-field-panel/AddFieldModalWithMutation.js